import PropTypes from 'prop-types';

function VerticalNavMenuSectionHeader({ item }) {
  return (
    <li className="navigation-header">
      <span>{item.header}</span>
    </li>
  );
}

VerticalNavMenuSectionHeader.propTypes = {
  item: PropTypes.shape({
    header: PropTypes.string.isRequired
  }).isRequired
};
export default VerticalNavMenuSectionHeader;
